module.exports = __webpack_public_path__ + "static/img/home_img1.6766e281.png";